import type { UserGroupsLocale } from './en'

export const userGroupsNe = {
  common: {
    cancel: `रद्द गर्नुहोस्`,
    close: `बन्द गर्नुहोस्`,
    delete: `मेटाउनुहोस्`,
    error: `त्रुटि`,
    yes: `हो`,
    no: `होइन`,
    requirePin: `PIN आवश्यक`,
    pin: `PIN`,
    auto: `स्वचालित`,
  },
  list: {
    title: `प्रयोगकर्ता समूहहरू`,
    searchPlaceholder: `नाम वा सदस्यबाट खोज्नुहोस्...`,
    searchAriaLabel: `प्रयोगकर्ता समूह खोज्नुहोस्`,
    createNew: `नयाँ प्रयोगकर्ता समूह`,
    createNewAriaLabel: `नयाँ प्रयोगकर्ता समूह सिर्जना गर्नुहोस्`,
    tableAriaLabel: `प्रयोगकर्ता समूह तालिका`,
    loading: `प्रयोगकर्ता समूहहरू लोड हुँदै...`,
    noResultsTitle: `कुनै नतिजा भेटिएन`,
    noResultsDescription: `खोज शब्दहरू मिलाएर फेरि प्रयास गर्नुहोस्`,
    emptyTitle: `अहिलेसम्म प्रयोगकर्ता समूह छैन`,
    emptyDescription: `पहिलो प्रयोगकर्ता समूह सिर्जना गरेर सुरु गर्नुहोस्`,
    autoGeneratedDeleteTooltip: `स्वचालित रूपमा बनेका समूहहरू मेटाउन सकिँदैन`,
    truncatedWarning: `{{total}} मध्ये पहिलो {{shown}} प्रयोगकर्ता समूहहरू देखाइँदैछ। केही समूहहरू सूचीमा छैनन् — कृपया सहयोग टोलीलाई सम्पर्क गर्नुहोस्।`,
    actionsForGroup: `{{name}} का कार्यहरू`,
    editGroup: `{{name}} सम्पादन गर्नुहोस्`,
    deleteGroup: `{{name}} मेटाउनुहोस्`,
    deleteGroupDisabled: `{{name}} मेटाउनुहोस् (अक्षम)`,
    accessAria: `{{label}}: {{status}}`,
    column: {
      name: `नाम`,
      members: `सदस्यहरू`,
      internal: `आन्तरिक`,
      local: `स्थानीय`,
      longDistance: `लामो दूरी`,
      domesticLongDistance: `लामो दूरी`,
      international: `अन्तर्राष्ट्रिय`,
      action: `कार्य`,
    },
    pagination: {
      perPage: `प्रति पृष्ठ:`,
      total: `(कुल {{count}})`,
      resultsPerPage: `प्रति पृष्ठ नतिजा`,
      previousPage: `अघिल्लो पृष्ठ`,
      nextPage: `अर्को पृष्ठ`,
      jumpToPage: `पृष्ठ {{page}} मा जानुहोस्`,
      morePages: `थप पृष्ठहरू`,
    },
    deleteDialog: {
      title: `प्रयोगकर्ता समूह मेटाउनुहोस्`,
      description: `"{{name}}" मेटाउने हो? यसले सबै सदस्य सम्बन्धहरू हटाउनेछ र फिर्ता गर्न सकिँदैन।`,
      successTitle: `प्रयोगकर्ता समूह मेटाइयो`,
      successDescription: `"{{name}}" मेटाइएको छ।`,
      alreadyDeletedTitle: `पहिले नै मेटिएको छ`,
      alreadyDeletedDescription: `यो प्रयोगकर्ता समूह भेटिएन - यो पहिले नै मेटिएको हुन सक्छ।`,
      failedDescription: `प्रयोगकर्ता समूह मेटाउन सकिएन।`,
    },
  },
  form: {
    addTitle: `प्रयोगकर्ता समूह थप्नुहोस्`,
    editTitle: `प्रयोगकर्ता समूह सम्पादन गर्नुहोस्`,
    loading: `प्रयोगकर्ता समूह लोड हुँदै...`,
    loadingError: `प्रयोगकर्ता समूह लोड गर्दा त्रुटि: {{message}}`,
    autoGeneratedNotice: `स्वचालित रूपमा बनेको समूह - केही फिल्डहरू प्रतिबन्धित छन्।`,
    nameLabel: `नाम`,
    namePlaceholder: `समूहको नाम प्रविष्ट गर्नुहोस्`,
    nameRequired: `नाम आवश्यक छ।`,
    nameMaxLength: `नाम 64 अक्षर वा कम हुनुपर्छ।`,
    accessPermissions: `पहुँच अनुमतिहरू`,
    members: `सदस्यहरू`,
    createUserGroup: `प्रयोगकर्ता समूह सिर्जना गर्नुहोस्`,
    saveChanges: `परिवर्तनहरू सुरक्षित गर्नुहोस्`,
    access: {
      internal: `आन्तरिक`,
      local: `स्थानीय`,
      domesticLongDistance: `घरेलु लामो दूरी`,
      international: `अन्तर्राष्ट्रिय`,
      tollNumbers: `टोल नम्बरहरू`,
      maliciousAreaCodes: `दुर्भावनापूर्ण क्षेत्र कोडहरू`,
      superAccess: `सुपर पहुँच`,
      eavesdropping: `इभ्सड्रपिङ`,
      promptRecording: `प्रम्प्ट रेकर्डिङ`,
    },
    memberPicker: {
      placeholder: `सदस्यहरू चयन गर्नुहोस्...`,
      searchPlaceholder: `सदस्यहरू फिल्टर गर्नुहोस्...`,
      emptyLabel: `यस पीबीएक्समा कुनै प्रयोगकर्ता तोकिएको छैन।`,
      noResultsLabel: `तपाईंको फिल्टरसँग मेल खाने प्रयोगकर्ता छैन।`,
      summary_one: `{{count}} सदस्य चयन गरियो`,
      summary_other: `{{count}} सदस्यहरू चयन गरियो`,
    },
  },
  toast: {
    createdTitle: `प्रयोगकर्ता समूह सिर्जना भयो`,
    updatedTitle: `प्रयोगकर्ता समूह अद्यावधिक भयो`,
    authRequiredTitle: `प्रमाणीकरण आवश्यक छ`,
    authRequiredDescription: `तपाईंको सत्र समाप्त भएको हुन सक्छ। कृपया फेरि प्रमाणीकरण गरेर प्रयास गर्नुहोस्।`,
    createFailedTitle: `प्रयोगकर्ता समूह सिर्जना गर्न सकिएन`,
    updateFailedTitle: `प्रयोगकर्ता समूह अद्यावधिक गर्न सकिएन`,
  },
} satisfies UserGroupsLocale
